import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { StrategyService } from '@shared/services/strategy.service';

@Component({
  selector: 'app-dialog-eve2-explanation',
  templateUrl: './dialog-eve2-explanation.component.html',
  styleUrls: ['./dialog-eve2-explanation.component.scss'],
  standalone: false
})
export class DialogEve2ExplanationComponent {
  @Output() dialogClose: EventEmitter<{ redirect: boolean }> = new EventEmitter<{ redirect: boolean }>();

  constructor(private strategyService: StrategyService) {}

  onDismiss(redirect): void {
    this.strategyService.dismissEve2Modal().subscribe(() => {
      this.dialogClose.emit({ redirect });
    });
  }
}
